<div class="tab-holder custom-tabs" *ngIf="fields?.length > 0">
  <div *ngIf="!uncompletedProfile" class="pt-3">
    <p>
      <button class="btn btn-link" (click)="seeMoreInfo()" data-test-id="see-more-info">
        <h4 class="mb-0 text-primary">
          {{ 'PROFILE_VIEW_SEE_MORE_PROFILE_INFO_HINT' | translate }}
        </h4>
      </button>
    </p>
  </div>

  <button class="btn btn-primary mb-4" data-test-id="btn-edit-profile" [routerLink]="LINK_PROFILE_EDIT">
    {{ (uncompletedProfile && !user.is_admin ? 'PROFILE_COMPLETE_DATA_HINT' : 'PROFILE_EDIT_DATA_HINT') | translate }}
  </button>
</div>
